import ReactGA from 'react-ga4';

export function logGAEvent(category, action, label, value) {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
}

export function logGAUser(user) {
  ReactGA.set({ user });
}
